<script>
export default {
  render() {
    return (
      <div class="page-empty">
        <div class="cont">
          <div class="cover" />
          {this.$slots.default}
        </div>
      </div>
    )
  }
}
</script>
<style lang="sass" scoped>
.page-empty
  height: 100vh
  padding-top: 308px
  display: flex
  justify-content: center

.cont
  color: rgb(170, 170, 187)
  font-size: 32px
  font-family: PingFangSC-Regular
  font-weight: normal
  text-align: center
.cover
  margin-bottom: 46px
  width: 292px
  height: 248px
  background: url(./cover.png) center no-repeat
  background-size: contain
</style>
